import { Edit, Trash } from "lucide-react";
import { useState, useEffect } from "react";
import { getAllTests } from "../../api/TestscoreAPI";
import ConfirmDeleteModal from "../ConfirmDeleteModal";

const TestCard = ({ testScore, onEdit, onDelete }) => {
  const [testFields, setTestFields] = useState([]);
  const [open, setOpen] = useState(false);

  const getAllTestFields = async () => {
    try {
      const response = await getAllTests();
      setTestFields(response.data || []);
    } catch (err) {
      console.error("Error fetching tests:", err.message);
      throw err;
    }
  };

  useEffect(() => {
    getAllTestFields();
  }, []);

  const fields = (testFields[testScore.exam_id] || []).filter(
    (f) => f.key !== "overall"
  );

  return (
    <div className="rounded-md ">
      <div className="flex justify-between items-start mb-2 border-t pt-4">
        <h3 className="text-lg font-medium text-[#572575] font-inter">
          {testScore.exam_name} Details
        </h3>
        <div className="flex items-center gap-4">
          <button
            onClick={() => onEdit(testScore)}
            className="flex items-center text-[#007BFF] font-bold"
          >
            <Edit className="h-5 w-5 mr-1" /> Edit
          </button>
          <button
            // onClick={() => onDelete(testScore.id)}
            onClick={() => setOpen(true)}
            className="flex items-center text-[#DF252A] font-bold"
          >
            <Trash className="h-5 w-5 mr-1" /> Delete
          </button>
        </div>
      </div>
      <ConfirmDeleteModal
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={() => {
          onDelete(testScore.id);
          setOpen(false);
        }}
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4  pb-4 font-inter mb-6">
        <div className="">
          <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
            <span className="text-[#727271] font-medium">Exam Type:</span>
            <p className="text-black">{testScore.exam_name}</p>
          </div>
          {/* School-level fields in correct order */}

          <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
            <span className="text-[#727271] font-medium">Overall:</span>
            <p className="text-black">{testScore.over_all}</p>
          </div>
          <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
            <span className="text-[#727271] font-medium">Date of Exam:</span>
            <p className="text-black">
              {new Date(testScore.date_of_exam).toISOString().split("T")[0]}
            </p>
          </div>
          <div className="grid grid-cols-[150px_1fr] py-1 mb-4">
            <span className="text-[#727271] font-medium">Date of Expiry:</span>
            <p className="text-black">
              {new Date(testScore.date_of_expiry).toISOString().split("T")[0]}
            </p>
          </div>
        </div>
        <div className="">
          {fields.map(({ key, label }) => (
            <div key={key} className="grid grid-cols-[180px_1fr] py-1 mb-4">
              <span className="text-[#727271] font-medium">{label}:</span>
              <p className="text-black">{testScore[key]}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestCard;
